import React from "react";

export function Section({ id, eyebrow, title, children, className = "", right, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-20 lg:py-28 border-t border-[#151515] ${className}`}>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        {(eyebrow || title) && (
          <div className="mb-12 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              {eyebrow && <div className="type-label text-[#C8102E] mb-3">{eyebrow}</div>}
              {title && <h2 className="type-h2">{title}</h2>}
            </div>
            {right}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
